import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Feeback from './PrototypeFeedback';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeConversationChoice extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            character_label: appHelper.getLocaleString("character_label"),
            you_label: appHelper.getLocaleString("you_label"),
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }


    render() {
        return (
            <div className="learner-action">
                <div className="question-wrapper conversation">
                    <div className="prototype customer_name_label">
                        <span>{this.state.character_label}</span>
                    </div>
                    <div className={`object-container`}>
                    <div className={`prototype character speak`}
                         dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_CHARACTER_CHOICE_PROMPT_TEXT}}/>
                    </div>
                    <div className={`object-container`}>
                        <div className="user_name_label prototype">
                            <span>{this.state.you_label}</span>
                        </div>


                        <div className={`prototype learner-action-option-list user theme-active question-checked`}>
                            <div className={`learner-action-option speak selected  reflective rounded`}
                                 style={{height: "auto"}}>
                                <input type="radio" name="prototype-conversation-field" disabled="disabled"/>
                                <label htmlFor={`prototype-conversation-field`}>
                                    <span
                                        dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_CHARACTER_CHOICE_RESPONSE_TEXT}}/>
                                </label>
                            </div>
                        </div>

                        <Feeback/>
                    </div>
                </div>
            </div>
        );
    }
}

PrototypeConversationChoice.propTypes = {
    locale: PropTypes.object,
};

PrototypeConversationChoice.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeConversationChoice);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeConversationChoice.js
 **/